import axios from "axios"
import Vue from 'vue'

import router from '../router/index'
import Encrypt from 'encryptlong'
import VueCookies from 'vue-cookies'
import {
  Message
} from 'view-ui-plus'
const Base64 = require("js-base64").Base64;
const jsSHA = require("jssha");
import {
  aes_ecb_decrypt,
  aes_ecb_encrypt,
  get_aes_uuid
} from '@/utils/my_crypto.js'
import Fingerprint2 from 'fingerprintjs2'



const CancelToken = axios.CancelToken;
axios.defaults.withCredentials = false; // 允许跨域携带cookie


// 添加请求拦截器
axios.interceptors.request.use(config => {
  var pathname = window.location.pathname;
  return config;
}, (error) => {
  return Promise.reject(error);
});


// 添加响应拦截器s
axios.interceptors.response.use((response) => {

  if (response.data.is_encrypt) {

    var _resp_data = JSON.parse(JSON.stringify(response.data))
    let decrypt = new Encrypt();
    var private_key = VueCookies.get('dx_private_key')
    decrypt.setPrivateKey(private_key);
    var aes_ecb_key = decrypt.decrypt(_resp_data.key)
    // 
    var data_str = aes_ecb_decrypt(_resp_data.data, aes_ecb_key)
    var decrypt_dict = JSON.parse(data_str)
    _resp_data['data'] = decrypt_dict

    if (process.env.NODE_ENV == 'development') {
      console.log('收到响应---', decrypt_dict)
    }

  } else {
    var _resp_data = response.data;
  }


  // token过期拦截
  if (_resp_data.code == 101) {

    Message.warning('H2-您当前登录过期，1秒后跳转至登录页面~');
    setTimeout(function () {
      var current_href = window.location.href;
      var auth_url = process.env.VUE_APP_AUTH_URL;
      open_new_page(auth_url + '?redirect_url=' + current_href, '_self')
    }, 1000)
    return

  }

  return _resp_data;

}, function (error) {

  return error;
});



function http(type, url, data, is_encrypt) {

  if (process.env.NODE_ENV == 'development') {
    console.log('发起请求---', data)
  }
  // 是否加密
  if (is_encrypt) {

    // console.log('需要加密')
    var encrypt = new Encrypt();
    var public_key = VueCookies.get('dx_public_key')
    var dx_token = VueCookies.get('dx_token')
    var dx_token_exist = VueCookies.isKey('dx_token')
    // 判断没cookies跳转到登录
    if (!dx_token_exist) {

      Message.warning('H1-您当前还未登录，1秒后跳转至登录页面~');
      setTimeout(function () {
        var current_href = window.location.href;
        var auth_url = process.env.VUE_APP_AUTH_URL;
        open_new_page(auth_url + '?redirect_url=' + current_href, '_self')
      }, 1000)

      return new Promise((resolve, reject) => {
        throw new Error('没cookies,登录error')
      })
    }

    // 场景数据-浏览器指纹
    let current_browser_id = VueCookies.get('dx_browser_id')
    var scene_data = {
      'browser_id': current_browser_id
    }
    data['scene_data'] = scene_data


    // 生成签名,加到请求体中
    var nonce = Math.random().toString(36).slice(2);
    data['nonce'] = nonce
    var timestamp = new Date().getTime()
    data['timestamp'] = timestamp

    var sign_str = dx_token + timestamp + nonce
    var sign_str_b64 = Base64.encode(sign_str);
    const shaObj = new jsSHA("SHA-256", "TEXT", {
      encoding: "UTF8"
    });
    shaObj.update(sign_str_b64);
    var sign_sha256 = shaObj.getHash("HEX");

    // /* Encrypt 加密*/
    var aes_key = get_aes_uuid()
    encrypt.setPublicKey(public_key);
    var rsa_decrypt_data = encrypt.encryptLong(aes_key)
    // aes加密
    var json_data = JSON.stringify(data)
    var aes_decrypt_str = aes_ecb_encrypt(json_data, aes_key)


    var data = {
      token: dx_token,
      data: aes_decrypt_str,
      sign: sign_sha256,
      aes_key: rsa_decrypt_data
    }


  } else {
    // console.log('不需要加密')
  }

  const source = CancelToken.source();
  var source_token = source.token
  let ajaxConfig = {
    method: type,
    url: url,
    data: data,
    proxy: true,
    headers: {
      'Content-Type': 'application/json'
    },
    cancelToken: source_token
  }


  return axios(ajaxConfig)
}


// 获取浏览器ID
function get_browser_id() {
  var id = Fingerprint2.get(function (components) {
    const values = components.map(function (component, index) {
      if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
        return component.value.replace(/\bNetType\/\w+\b/, '')
      }
      return component.value
    })
    // 生成最终id murmur   
    var murmur = Fingerprint2.x64hash128(values.join(''), 31)
    VueCookies.set('browser_id', murmur)
  })

}

function download_file(url, name) {
  // var url = this.down_url;
  // var name = this.filename;

  fetch(url)
    .then((_) => _.blob())
    .then((_) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(_);
      link.setAttribute("download", name); // 自定义文件名
      link.click();
    });
}


function open_new_page(url, target) {
  if (!target) {
    target = '_blank'
  }
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("target", target);
  var id = String(new Date().getTime())
  a.setAttribute("id", id);
  // 防止反复添加      
  document.body.appendChild(a);
  a.click();

}



function get_view_file_url(object_name) {

  var object_name_b64 = Base64.encode(object_name)
  console.log(123)
  console.log(object_name_b64)
  console.log(123)
  var domain = window.location.hostname
  window.open('https://file.daxiangsys.com?object_name=' + object_name_b64 + '&domain=' + domain)
}





// 搜索地点
function searchPlace(keyword, city) {
  if (!keyword || !city) {
    return Promise.reject(new Error('keyword 或 city 不能为空'))
  }

  const params = {
    key: '5D4BZ-CUL6Z-4I7XK-ZEYXW-7NEJ3-GEF75',
    keyword: keyword.trim(),
    boundary: `region(${city.trim()},0)`
  }

  return axios.get('https://apis.map.qq.com/ws/place/v1/search', {
    params
  })
}

export {
  http,
  get_browser_id,
  open_new_page,
  get_view_file_url,
  download_file,
  searchPlace
}